// The one-shot notice shown after the API told us we were removed from the
// workspace we had open and we were moved to another one of ours. It crosses
// the hard reload in sessionStorage (read once on load, then cleared).

const NOTICE_KEY = 'goblic.workspaceNotice'

export function buildWorkspaceNotice(previousName: string | null | undefined, nextName: string | null | undefined): string {
  const from = previousName?.trim() ? `“${previousName.trim()}”` : 'that workspace'
  return nextName?.trim()
    ? `You no longer have access to ${from}; switched to “${nextName.trim()}”.`
    : `You no longer have access to ${from}; switched to another workspace.`
}

export function setWorkspaceNotice(message: string): void {
  try {
    sessionStorage.setItem(NOTICE_KEY, message)
  } catch {
    // Storage blocked: the switch still works, only the notice is lost.
  }
}

/** Returns the pending notice and clears it. */
export function takeWorkspaceNotice(): string | null {
  try {
    const message = sessionStorage.getItem(NOTICE_KEY)
    if (message) sessionStorage.removeItem(NOTICE_KEY)
    return message
  } catch {
    return null
  }
}
